var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiteBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376.309,
    height: 250.399,
    viewBox: "0 0 376.309 250.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42165",
    "data-name": "Path 42165",
    d: "M221.278,295.25a225.122,225.122,0,0,1-27.59-3.691c-10.5-2.26-17.255-2.854-32.4-2.85a320.939,320.939,0,0,0-43.152,2.922c-12.259,1.9-27.993,1.064-38.354-2.026a17.432,17.432,0,0,1-9.824-8.484c-1.265-2.52-1.458-4.086-1.458-11.807a62.242,62.242,0,0,1,2.069-17.8l2.069-8.9,2.687-24.585c-.04-22.4-3-31.82-3.89-36.455C68.884,168.349,69.3,155.58,73.034,132c3.577-22.572,3.42-29.117-1.1-46.1-3.1-11.649-3.536-15.854-2.147-20.851,3.978-14.312,13.71-20.308,30.163-18.585,3.248.34,13.951,2.522,23.786,4.848,17.16,4.058,18.228,4.231,26.5,4.291,7.592.055,9.363-.148,14.821-1.7,8.7-2.477,17.5-3.67,30.7-4.165,16.274-.61,38.2.192,61.515,2.251,19.013,1.679,22.215,1.785,53.672,1.773,37.234-.013,47.062-.614,69.948-4.278a121.078,121.078,0,0,1,24.2-2.014c8.981-.013,12.775.24,16.209,1.083,9.982,2.451,14.538,2.4,18.025,10.231s-3.718,17.7-3.395,30.461c.49,19.3,7.411,24.311,7.811,40.558s-.514,20.173-5.532,36.819c-3.057,10.138-3.036,28.032.077,64.549,2.091,24.532,2.492,43.709,1.037,49.595-1.258,5.091-3.72,9.434-6.314,11.137-2.509,1.647-9.187,2.564-15.805,2.171-2.49-.148-9.8-.571-16.253-.94s-24.738-1.658-40.642-2.863-32.26-2.192-36.348-2.192a177.783,177.783,0,0,0-31.356,3.446c-17.194,3.238-29.477,4.21-51.33,4.06-8.915-.061-17.916-.207-20-.326",
    transform: "translate(-68 -45.685)",
    fill: "#eaf8fa",
    stroke: "#eff1f5",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteBlueBg);
export default __webpack_public_path__ + "static/media/liteBlueBg.9e5813ec93a32ecf2daf39f78dc151ba.svg";
export { ForwardRef as ReactComponent };